import { useContext, useEffect, useRef, useState } from 'react';
import { Alert, Button, Col, Dropdown, Form, Input, Modal, Row, Select, Space, Table, Tooltip } from 'antd';
import fetchApi from '../../../utils/api/fetchApi';
import systemConfig from '../../../config/systematic';
import antMessage from '../../../utils/extend/AntdNotification';
import { SocketContext } from '../../../App';
import { SearchOutlined } from '@ant-design/icons';
import { showCustomNotification, useNotificationInstance } from '../../../utils/extend/AntdNotificationEx';

//组件 InternalStatisticsSetting 
export default function InternalStatisticsSetting(props: any) {

    const ref = useRef<any>(undefined);
    const [form] = Form.useForm();

    const notificationApi = useNotificationInstance();
    const useContextData = useContext(SocketContext);
    const { contextData, setContextData } = useContextData;

    /** 数据刷新中 */
    let loadings = false;

    /** 后端数据wmService */
    let wmService: any = systemConfig.wmService;

    /** api服务id */
    const apiId = 'branchStoreMenuWarehouse';

    //统计分类窗口
    const [internalStatisticsTypeData, setInternalStatisticsTypeData] = useState();
    const [internalStatisticsTypeIdData, setInternalStatisticsTypeIdData] = useState();
    const [loadingData, setLoadingData] = useState<any>(false);

    const [currentData, setCurrentData] = useState(1);
    const [pageSizeData, setPageSizeData] = useState(10);
    const [totalData, setTotalData] = useState(0);
    const [queryInput, setQueryInput] = useState();

    //基础数据
    const [rows, setRows] = useState<any>([]);

    //当前的批量操作方式
    const [currentBatchOperation, setCurrentBatchOperation] = useState<any>();

    //当前的菜名
    const [currentFoodName, setCurrentFoodName] = useState<any>();

    //批量操作窗口
    const [showBatchOperationVisible, setShowBatchOperationVisible] = useState(false);

    /**选中的所有数据 */
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

    const batchOperations = [
        {
            key: 'changeInternalStatisticsType',
            label: selectedRowKeys.length > 0 ? '改统计分类' : (
                <Tooltip title="请先选择菜品" key="leftButton">
                    改统计分类
                </Tooltip>
            )
            // disabled: true,
        },
    ];

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            // wmService = ref.current.wmService;
        }

        //同步获取数据 async - await
        const fetchData = async () => {

            await initData({ internalStatisticsTypeId: internalStatisticsTypeIdData });

            fetchApi.GET(wmService, {
                apiId: "internalStatisticsCategory",
                apiExtend: 'showTypeList',
                apiVariable: contextData?.currentAreaId
            }).then((res) => {
                if (res.success) {
                    setNewData(res.data, setInternalStatisticsTypeData);
                }
            })
        }

        if (contextData?.currentBranchStoreId) {
            if (contextData?.refresh) {
                onRefresh({ branchStoreId: contextData?.currentBranchStoreId })
            }
        }


        fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contextData?.currentBranchStoreId]); //初始化数据

    //表头
    const columnsHead = [
        {
            title: '门店',
            dataIndex: 'branchStoreName',
            render: (text: any, record: any) => {
                return (
                    <div>{record.branchStore.brand.brandName + " " + record.branchStore.branchStoreName}</div>
                )
            }
        },
        {
            title: '菜式',
            dataIndex: 'foodName',
        },
        {
            title: '统计分类',
            dataIndex: 'internalStatisticsTypeName',
            render: (text: any, record: any) => {
                return (
                    <div>{record.internalStatisticsType?.internalStatisticsTypeName}</div>
                )
            }
        },
        {
            title: '操作',
            dataIndex: '',
            key: 'option',
            render: (text: any, record: any) => {
                return (
                    <Space size="small">
                        <Button size={"small"} type="text" onClick={() => handleBatchOperation({
                            isSingle: true,
                            id: record.id,
                            foodName: record.foodName
                        })}>编辑</Button>
                    </Space>
                )
            }
        },
    ];

    const setNewData = (rows: any, setData: any) => {
        let finalData: any = [];
        let childrenData: any = [];
        for (let i = 0; i < rows.length; i++) {
            let internalStatisticsType = rows[i].internalStatisticsTypes;
            for (let j = 0; j < internalStatisticsType.length; j++) {
                childrenData.push({
                    label: internalStatisticsType[j].internalStatisticsTypeName, value: internalStatisticsType[j].id
                })
            }
            finalData.push({
                label: rows[i].internalStatisticsCategoryName,
                title: rows[i].internalStatisticsCategoryName,
                options: childrenData
            })
            childrenData = [];
        }
        
        setData(finalData);
    }

    const initData = async (parameter: any) => {
        fetchApi.GET(wmService, {
            apiId,
            apiExtend: 'showPage',
            apiData: {
                current: currentData,
                pageSize: pageSizeData,
                queryString: queryInput,
                sendPageData: {
                    internalStatisticsTypeId: parameter.internalStatisticsTypeId,
                    branchStoreId: parameter.branchStoreId ? parameter.branchStoreId : contextData?.currentBranchStoreId
                },
                mountDataOptions: {
                    userMount: {
                        isDept: true
                    }
                }
            }
        }).then((res) => {
            if (res.success) {
                setRows(res.data.rows);
                setCurrentData(res.data.current);
                setPageSizeData(res.data.pageSize);
                setQueryInput(res.data.queryString);
                setTotalData(res.data.total);
            }
        })
    }

    //查看统计的菜式
    const internalStatisticsTypeChange = async (e: any) => {
        setInternalStatisticsTypeIdData(e);
        await initData({ internalStatisticsTypeId: e });
    }

    const onRefresh = async (item: any) => {
        const { branchStoreId } = item;
        await initData({ internalStatisticsTypeId: internalStatisticsTypeIdData, branchStoreId });
        setContextData({ ...contextData, refresh: false })
    }

    /**
     * 获取数据
     * @param options 选项
     * @returns 
     */
    const getPageData = async (options?: {
        /** 当前页 */
        current?: number,
        /** 分页数量 */
        pageSize?: number,
    }) => {
        if (typeof options === 'undefined') {
            options = {};
        }

        let { current, pageSize } = options;
        let queryString = queryInput;
        current = current ? current : currentData;
        pageSize = pageSize ? pageSize : pageSizeData;

        if (loadings === true) { return }
        loadings = true;
        fetchApi.GET(wmService, {
            apiId,
            apiExtend: 'showPage',
            apiData: {
                current,
                pageSize,
                queryString,
                sendPageData: {
                    internalStatisticsTypeId: internalStatisticsTypeIdData,
                    branchStoreId: contextData?.currentBranchStoreId
                },
                mountDataOptions: {
                    userMount: {
                        isDept: true
                    }
                }
            }
        }).then(res => {
            if (res.success === true) {
                setRows(res.data.rows);
                setCurrentData(res.data.current);
                setPageSizeData(res.data.pageSize);
                setQueryInput(res.data.queryString);
                setTotalData(res.data.total);
            }
            loadings = false;
        })
    };

    // 表格分页属性
    const paginationProps = {
        showSizeChanger: true,
        showQuickJumper: false,
        showTotal: () => `共${totalData}条`,
        pageSize: pageSizeData,
        current: currentData,
        total: totalData,
        onShowSizeChange: (current: number, pageSize: number) =>
            getPageData({ current, pageSize }),
        onChange: (current: number) =>
            getPageData({ current }),
    };

    //记录选中的菜式Id
    const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    //处理批量操作
    const handleBatchOperation = async (e: any) => {
        if (e.isSingle) {
            setSelectedRowKeys([e.id]);
            setCurrentFoodName(e.foodName);
            setShowBatchOperationVisible(true);
            setCurrentBatchOperation("changeInternalStatisticsType");
            form.setFieldsValue({ key: "changeInternalStatisticsType" });
        }
        // console.log('click', e);
        // console.log("selectedRowKeys");
        // console.log(selectedRowKeys);
        // console.log("---------------------------");
        switch (e.key) {
            //批量改统计分类
            case "changeInternalStatisticsType":
                // console.log("这是批量改分类");
                if (selectedRowKeys.length > 0) {
                    setShowBatchOperationVisible(true);
                    setCurrentBatchOperation(e.key);
                    form.setFieldsValue({ key: e.key });
                }
                break;
        }
    };

    const batchOperationOk = (e: any) => {
        form.validateFields() //数据校验
            .then(async (values: any) => {
                setLoadingData(true);
                fetchApi.PUT(wmService, {
                    apiId,
                    apiExtend: "batchOperation",
                    apiData: {
                        ...values,
                        apiId,
                        branchStoreId: contextData?.currentBranchStoreId,
                        branchStoreMenuWarehouseIds: selectedRowKeys,
                        mountDataOptions: {
                            userMount: {
                                isDept: true
                            }
                        },
                    }
                }).then(async res => {
                    if (res.success) {
                        setLoadingData(false);
                        antMessage('success', '添加成功', 'success');
                        onCloseBatchOperation();
                        setSelectedRowKeys([]);
                        setCurrentFoodName(undefined);
                        await initData({ internalStatisticsTypeId: internalStatisticsTypeIdData });
                    }
                }).catch(err => {
                    antMessage('error', '错误，无法保存', err.message + ' | status:' + err.errors.status);
                })
            }).catch((err: any) => {
                showCustomNotification(notificationApi!, {
                    type: 'warning',
                    message: "无法通过数据校验",
                    description: "请输入所需数据!"
                });
            });
    };

    //关闭批量操作窗口
    const onCloseBatchOperation = () => {
        setShowBatchOperationVisible(false);
        form.setFieldsValue({ internalStatisticsTypeId: null });
        setCurrentFoodName(undefined);
        setSelectedRowKeys([]);
    }

    /** 查询 */
    const handleQuery = (e: any) => {
        let value = e.target.value;
        setQueryInput(value);
    };

    /**
     * 查询数据
     * @param queryString 查询的内容
     * @param options 选项 
     */
    const queryData = async () => {
        await initData({ internalStatisticsTypeId: internalStatisticsTypeIdData });
    };

    return (
        <>
            <Space>
                <Select
                    style={{ width: 150 }}
                    allowClear
                    showSearch
                    placeholder="统计分类"
                    onChange={internalStatisticsTypeChange}
                    optionFilterProp="children"
                    filterOption={(input, option: any) =>
                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                    options={internalStatisticsTypeData}
                >
                </Select>
                <Input
                    placeholder="请输入查询内容"
                    onChange={(e: any) => handleQuery(e)}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter')
                            queryData()
                    }} />
                <Button icon={<SearchOutlined />} onClick={queryData}>查询</Button>
                <Dropdown.Button type="primary" menu={{ items: batchOperations, onClick: handleBatchOperation }} trigger={["hover"]}>批量</Dropdown.Button>
            </Space>

            <Modal
                title={currentFoodName ? "【 " + currentFoodName + " 】" : "批量操作"}
                open={showBatchOperationVisible}
                onOk={batchOperationOk}
                onCancel={onCloseBatchOperation}
                closable={false}
                style={{ fontSize: '20px' }}
                okButtonProps={{ disabled: loadingData }}
                confirmLoading={loadingData}
                maskClosable={false}
                width={500}
            >
                <Form
                    form={form}
                    name="Edit"
                    style={{ height: 450 }}
                >
                    <Row gutter={[8, 0]}>
                        <Col span={0}>
                            <Form.Item
                                label="key"
                                name="key">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        {!currentFoodName ?
                            <>
                                <Col span={24}>
                                    <Form.Item>
                                        <Alert
                                            message={"共选择了 " + selectedRowKeys.length + " 个菜式 , 进行以下批量操作"}
                                            // description="进行以下批量操作"
                                            type="success"
                                            style={{ fontSize: 30 }}
                                        />
                                    </Form.Item>
                                </Col>
                            </> : ''}

                        {currentBatchOperation === 'changeInternalStatisticsType' ?
                            <>
                                <Col span={24}>
                                    <Form.Item
                                        label="选择统计类别"
                                        name="internalStatisticsTypeId"
                                        rules={[{ required: currentBatchOperation === 'changeShopType' ? true : false, message: '请选择统计类别!' }]}>
                                        <Select
                                            style={{ width: 150 }}
                                            allowClear
                                            showSearch
                                            placeholder="统计分类"
                                            optionFilterProp="children"
                                            filterOption={(input, option: any) =>
                                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            options={internalStatisticsTypeData}
                                        >
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </> : ""}

                    </Row>
                </Form>
            </Modal>

            <div style={{ marginTop: "20px" }}>
                <Table
                    rowSelection={{
                        selectedRowKeys,
                        onChange: onSelectChange,
                        type: "checkbox",
                    }}
                    pagination={paginationProps}
                    rowKey={(record: any) => record.id}
                    columns={columnsHead}
                    dataSource={rows}
                >
                </Table>
            </div>
        </>
    )
}